"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var router = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
    var type, payload, requestId, oxygenId, Authorization, routerLambdaUrl, initilizedPayload, headers, res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            type = _ref.type, payload = _ref.payload, requestId = _ref.requestId, oxygenId = _ref.oxygenId, Authorization = _ref.Authorization, routerLambdaUrl = _ref.routerLambdaUrl;
            // Initilize payload and header
            initilizedPayload = {
              type: type,
              payload: payload,
              oxygenId: oxygenId
            };
            headers = {
              'Content-Type': 'application/json',
              Session: requestId,
              Authorization: Authorization
            }; // Call api

            _context.prev = 3;
            _context.next = 6;
            return _axios.default.post(routerLambdaUrl, initilizedPayload, {
              headers: headers
            });

          case 6:
            res = _context.sent;
            return _context.abrupt("return", res.data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            console.error(_context.t0);
            throw _context.t0;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  }));

  return function router(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = router;
exports.default = _default;